module.exports = __webpack_public_path__ + "img/instagram.00939b7e.svg";